import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.gray900};
`;

export const StatusBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 24px;
  background-color: ${({ theme }) => theme.colors.gray800};
`;

export const StatusLabel = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  gap: 16px;
  padding: 60px 0 50px 0;
  max-height: 90vh;
  overflow: scroll;
`;

export const ButtonIcon = styled.span`
  font-size: 24px;
`;
